import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/not-found.tsx");
